var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"title-small text-uppercase letter-spacing-3 black-text font-weight-600",domProps:{"innerHTML":_vm._s(_vm.getTitle)}}),_c('div',{staticClass:"mt-2 ",domProps:{"innerHTML":_vm._s(_vm.getDescription)}})])}
var staticRenderFns = []

export { render, staticRenderFns }